module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.$store.state.company.name) + "\n    "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.apiBusy
    },
    on: {
      "click": function($event) {
        return _vm.refreshAll()
      }
    }
  }, [_vm._v("\n      Check for New Orders\n    ")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "1.25rem",
      "white-space": "nowrap"
    }
  }, [_vm._v("(last checked " + _vm._s(_vm.last_check) + ")")])]), _vm._v(" "), _c('nav', {
    staticClass: "level level-links has-text-centered"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm._f("pluralize")(_vm.newOrders.length, "New Order")))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.newOrders.length))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'printed-orders'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Printed Orders")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.printedOrders.length))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("All Orders")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allNonVoidedOrders.length))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'requests'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm._f("pluralize")(_vm.newCatalogRequests.length, "Catalog Request")))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.newCatalogRequests.length))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'subscriptions'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm._f("pluralize")(_vm.subscriptions.length, "Subscription")))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.subscriptions.length))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('router-link', {
    staticClass: "level-item-link",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm._f("pluralize")(_vm.users.length, "Account")))]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.users.length))])])], 1)]), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-196ee701"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Dashboard.vue
// module id = 504
// module chunks = 0